/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "../../components/MKBox";
import MKTypography from "../../components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "../../examples/Navbars/DefaultNavbar";
import DefaultFooter from "../../examples/Footers/DefaultFooter";

// About Us page sections
import Testimonials from "./sections/Testimonials";
import ContactUs from "./sections/ContactUs";

// Routes
import routes from "../../routes";

// Images
import bgImage from "../../assets/images/emtay/bg-emtay.webp";
import Counters from "./sections/Counters";
import Features from "./sections/Features";

import { legalbar } from "./sections/legalbar";
import Technologies from "./sections/Technologies";

function EmtayPage() {
  const isThanks = window.location.pathname == "/thanks";

  return (
    <>
      <a name="top" />
      <DefaultNavbar routes={routes} transparent light />
      <MKBox
        minHeight="65vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={8}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{ mx: "auto", textAlign: "center" }}
          >
            <MKTypography
              variant="h1"
              color="white"
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              Emtay: Meedenken en Toepassen
            </MKTypography>
            <MKTypography variant="body1" color="white" opacity={0.8} mt={1} mb={3}>
              Wij helpen organisaties om complexe softwarevraagstukken eenvoudig te benaderen.
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 2,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        {isThanks ? <ContactUs isThanks={true} /> : null}
        <Counters />
        <a name="services" />
        <Features />
        <Technologies />
        <a name="contact" />
        {!isThanks ? <ContactUs isThanks={false} /> : null}
        <Testimonials />
      </Card>
      <MKBox pt={2} px={1} mt={0} py={0}>
        <DefaultFooter content={{ copyright: legalbar }} />
      </MKBox>
    </>
  );
}

export default EmtayPage;
